/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppMarkdownDisplay.vue?vue&type=template&id=2b016c38&scoped=true"
import script from "./AppMarkdownDisplay.ts?vue&type=script&lang=ts&external"
export * from "./AppMarkdownDisplay.ts?vue&type=script&lang=ts&external"
import style0 from "./AppMarkdownDisplay.vue?vue&type=style&index=0&id=2b016c38&prod&lang=css&scoped=true"
import style1 from "./AppMarkdownDisplay.vue?vue&type=style&index=1&id=2b016c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b016c38",
  null
  
)

export default component.exports